import React from 'react'
import HeroSection from './HeroSection'
import IndustryHook from './IndustryHook'
import WhyJoinUs from './WhyJoinUs'
import CultureSection from './CultureSection'
import OpenRoles from './OpenRoles'
import Journey from './Journey'
import CTASection from './CTASection'

const index = () => {
  return (
    <div>
       <HeroSection/>
       <IndustryHook/>
       <WhyJoinUs/>
       <CultureSection/>
       <OpenRoles/>
       <Journey/>
       <CTASection/>
    </div>
  )
}

export default index